/*
 * @Author: monai
 * @Date: 2021-05-08 18:28:20
 * @LastEditors: yexiu
 * @LastEditTime: 2024-05-29 11:09:37
 */
import { createApp, reactive } from "vue";
import toastComponent from "./toast.vue";
import {fnColorLog} from '@activity-business/h5-package-frameworkTool';

const root: HTMLDivElement = document.createElement("div");
document.body.appendChild(root);

/**
 * provideFunc
 * @param moduleVersion 版本号
 * @param globalConfig 全局自定义配置
 * @returns config 当前配置
 */
const provideFunc: (moduleVersion?: string, globalConfig?: Partial<DevelopToolShare.ToastConfig>) => (config?: Partial<DevelopToolShare.ToastConfig>) => void = (moduleVersion, globalConfig) => {

    /**
     * v1 版本
     */
    const v1 = () => {
        let defalutConfig: DevelopToolShare.ToastConfig = {
            text: "Network Error!",
            style: {},
            showTime: 2 * 1000,
            visible: false
        };
        let reactiveDefalutConfig = reactive(defalutConfig);
        createApp(toastComponent, { config: reactiveDefalutConfig }).mount(root);
        return (config = {}) => Object.assign(reactiveDefalutConfig, { visible: true }, config);
    };

    /**
     * v2 版本
     */
    const v2 = () => {
        const defalutConfig: DevelopToolShare.ToastConfig = {
            text: "Network Error!",
            style: {},
            showTime: 2 * 1000,
            visible: false,
            ...globalConfig
        };
        const reactiveDefalutConfig = reactive({ ...defalutConfig });
        createApp(toastComponent, { config: reactiveDefalutConfig }).mount(root);
        return (config = {}) => Object.assign(reactiveDefalutConfig, { ...defalutConfig, visible: true }, config);
    };

    // 最新版本
    const latestVersion = "v2";
    switch (moduleVersion) {
        case "v1":
            return v1();
        case "v2":
            return v2();
        default:
            fnColorLog(
                moduleVersion
                    ? `Toast Component Warning > 未找到版本号: ${moduleVersion}，将使用默认版本号: v1`
                    : `Toast Component Warning > 未设置版本号，将使用默认版本号: v1，请在 main.ts 中设置版本号`,
                'warning'
            );
            fnColorLog(`Toast Component Warring > 最新版本号为: ${latestVersion}`, 'info');
            return v1();
    }
};
export default provideFunc;
